<template>
    <div>
        <shareSheet
            v-if="shareSheetShown"
            :postID="postId"
            :gifURL="postData.image_url"
            @hideShareSheet="shareSheetShown=false"
        />

        <loadingSkeleton v-if="!postData" />

        <div class="gif-container" v-if="postData">
            <div class="gif-img">
                <router-link v-if="postId" :to="'/post/'+postId">
                    <img v-if="postData.image_url" :src="postData.image_url" alt="">
                </router-link>
                <img v-else :src="postData.image_url" alt="">
            </div>

            <div class="gif-cred">
                <div class="gif-posted-by" v-if="postData.creator_email">
                    <div class="gif-created-by-title">Created by</div>
                    <a class="gif-creator-name" :href="'mailto:' + postData.creator_email">{{postData.creator}}</a>
                </div>
                <div class="gif-posted-by" v-else>
                    <div class="gif-created-by-title">Created by</div>
                    <div class="gif-creator-name">{{postData.creator}}</div>
                </div>
                <div class="gif-posted-on">
                    {{getTimeStamp(postData.timestamp).date}} at {{getTimeStamp(postData.timestamp).time}}
                </div>
            </div>
            <div class="gif-options">
                <a
                class="btn btn-s btn-secondary btn-icon-16 btn-icon-download"
                :href="postData.image_url"
                target="_blank"
                download
                >
                    Download
                </a>
                <button
                    @click="shareSheetShown=true"
                    class="btn btn-s btn-secondary btn-icon-16 btn-icon-share">
                    Share
                </button>
            </div>
        </div>
    </div>
    
</template>

<script>
import shareSheet from '@/components/shareSheet'
import loadingSkeleton from '@/components/loadingSkeleton'

// Firebase
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/analytics'

export default {
    name: 'gifCard',
    props: {
        postId: String,
    },
    components: {
        shareSheet,
        loadingSkeleton,
    },
    data() {
        return {
            shareSheetShown: false,
            // post: {
            //     creator: null,
            //     creator_email: null,
            //     image_url: null,
            //     id: null,
            //     timestamp: null,
            // },
            postData: null,
        }
    },
    methods: {
        getTimeStamp(timestamp) {
          let
              days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              d = new Date(timestamp),
              day = days[d.getDay()],
              date = d.getDate(),
              month = months[d.getMonth()],        
              hours = d.getHours(),
              minutes = d.getMinutes()
          ;
          // Add "0" before the minutes if it's less than 10 mins
          (minutes < 10) ? minutes = "0" + minutes : minutes;
          
          return {
              time: `${hours}:${minutes} PT`,
              date: `${day} ${month} ${date}`,
          }
      },
      fetchPostFromDB(postId) {
          let database = firebase.database();
          let ref = database.ref(`posts/${postId}/`);
          ref.on('value', this.gotData, this.errData);
      },
      gotData(data) {
          let dataReceived = data.val();
          
          if (dataReceived) {
              this.postData = dataReceived;
          } else {
              console.error('⚠️ There is no such post!');
              this.$emit('doesntExist');
          }
      },
      errData(error) {
          console.error('Error while trying to get data from db', error);
      },
    },
    mounted() {
        this.fetchPostFromDB(this.postId);
    },
}
</script>

<style>

</style>